<template>
    <section v-if="rolesIs(all_roles)"
             class="flex items-center absolute bottom-0 right-0 mb-2 mr-1 px-2 py-1 bg-main-tint rounded-full">
        <!--        <span v-tippy="{content: $t('library.edit'), arrow: true, theme: 'accent', maxWidth: 316, touch: true}"-->
        <!--              :class="CSS.admin_btn"-->
        <!--              @click="editModel(model, element.id)"-->
        <!--              v-html="collection.edit.path" />-->
        <span v-tippy="{content: 'Временно не работает', arrow: true, theme: 'red', maxWidth: 316, touch: true}"
              :class="CSS.admin_btn"
              v-html="collection.edit.path" />
        <span v-if="element.published_at"
              v-tippy="{content: $t('library.hide'), arrow: true, theme: 'accent', maxWidth: 316, touch: true}"
              :class="CSS.admin_btn"
              @click="togglePublishedAt(model, element.id)"
              v-html="collection.show.path"/>
        <span v-if="!element.published_at"
              v-tippy="{content: $t('library.show'), arrow: true, theme: 'accent', maxWidth: 316, touch: true}"
              :class="CSS.admin_btn"
              @click="togglePublishedAt(model, element.id)"
              v-html="collection.hide.path"/>
        <span v-tippy="{content: $t('library.delete'), arrow: true, theme: 'accent', maxWidth: 316, touch: true}"
              :class="CSS.admin_btn"
              @click="deleteModel(model, element.id)"
              v-html="collection.trash.path"/>
    </section>
</template>
<script setup>
import { icons as collection } from '@/shared/assets.js';
import {rolesIs, togglePublishedAt, deleteModel, editModel} from '@/shared/helpers.js';
import {computed} from 'vue';

const props = defineProps(['element', 'model', 'roles']);

let CSS = {
    admin_btn: ['mx-1', 'cursor-pointer', 'text-main-secondary', 'transform', 'opacity-70', 'hover:opacity-100', 'transition', 'duration-100', 'hover:text-main-accent'],
};

let all_roles = computed(() => props.roles && props.roles.length ? [...props.roles, 1,7] : [1,7]);
</script>